import React, { useEffect, useState } from 'react';

import EFakturaList from '../../../components/EFakturaList/EFakturaList';
import useTranslation from '../../../hooks/useTranslation';
import { eFakturas } from '../demoData';

const DemoTaskManager: React.FC = () => {
    const translated = useTranslation();

    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoading(false), 500);
    }, []);

    return (
        <section className="task-manager__wrapper sgw-content" style={{ marginTop: 32 }}>
            <h2 className="typography-subtitle-bold task-manager__title">{translated.tasks}</h2>
            <div className="task-manager__list-wrapper">
                <EFakturaList type="task-manager-list" eFakturas={eFakturas} error={null} isLoading={isLoading} />
            </div>
        </section>
    );
};

export default DemoTaskManager;
